module.exports = __webpack_public_path__ + "static/objects-f9b976c74c24ef06770a712a8e8d8a57.svg";